import React from 'react';
import '../styles/reject.css';
import leftImage from '../assets/landing1.png';
import warningIcon from '../assets/wrong.png';

const Reject = () => {
  const handleLoginRedirect = () => {
    // Add navigation to login page here
    console.log('Redirecting to login page...');
    // You can use: window.location.href = '/login'; or navigate('/login') if using React Router
  };

  return (
    <div className="reject-page">
      {/* Left Image Section */}
      <div className="left-side">
        <img src={leftImage} alt="Lingayath Weds" className="left-image" />
      </div>

      {/* Right Reject Section */}
      <div className="right-side">
        <div className="reject-card">
          <h1 className="title">Welcome to Lingayath Weds</h1>
          
          <div className="reject-content">
            {/* Warning Icon */}
            <div className="icon-container">
              <img src={warningIcon} alt="Warning" className="warning-icon" />
            </div>
            
            {/* Reject Message */}
            <p className="reject-message">
              Your registration has been rejected. Please contact the administrator for further assistance.
            </p>

            {/* Go to Login Button */}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reject;